import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { Card, CardBlock, CardTitle } from 'reactstrap';

const GenericCard = ({ content }) => (
  <Card className="generator-preview generator-preview--with-reviews generator-preview--is-primary" style={{ height: '501.781px' }}>
    <CardBlock className="card-body generator-preview__body">
      <CardTitle style={{ paddingTop: '40%' }} dangerouslySetInnerHTML={{ __html: content }} />
    </CardBlock>
  </Card>
);

GenericCard.propTypes = {
  content: PropTypes.string,
};

const enhance = compose();

export default enhance(GenericCard);



// WEBPACK FOOTER //
// ./src/components/GenericCard.js